import { render } from "./all-laporan-akreditasi.vue?vue&type=template&id=7187d40a"
import script from "./all-laporan-akreditasi.vue?vue&type=script&lang=js"
export * from "./all-laporan-akreditasi.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__